module.exports = __webpack_public_path__ + "img/img.476dd32d.png";